import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import styles from "./SNSInformation.module.scss";

type Props = {
  twitch?: string;
  twitter?: string;
  instagram?: string;
  facebook?: string;
  youtube?: string;
  isTeam?: boolean;
};
const SNSInformation: React.FC<Props> = ({
  twitch,
  twitter,
  instagram,
  facebook,
  youtube,
  isTeam = false,
}) => {
  return (
    <ul className={isTeam ? styles["sns-info-team"] : styles["sns-info"]}>
      {twitter ? (
        <li className={`${styles["sns-info__icon"]} ${styles["twitter"]}`}>
          <a href={twitter} target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={["fab", "x-twitter"]} />
          </a>
        </li>
      ) : null}
      {instagram ? (
        <li className={`${styles["sns-info__icon"]} ${styles["instagram"]}`}>
          <a href={instagram} target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={["fab", "instagram"]} />
          </a>
        </li>
      ) : null}
      {facebook ? (
        <li className={`${styles["sns-info__icon"]} ${styles["facebook"]}`}>
          <a href={facebook} target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={["fab", "facebook"]} />
          </a>
        </li>
      ) : null}
      {youtube ? (
        <li className={`${styles["sns-info__icon"]} ${styles["youtube"]}`}>
          <a href={youtube} target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={["fab", "youtube"]} />
          </a>
        </li>
      ) : null}
      {twitch ? (
        <li className={`${styles["sns-info__icon"]} ${styles["twitch"]}`}>
          <a href={twitch} target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={["fab", "twitch"]} />
          </a>
        </li>
      ) : null}
    </ul>
  );
};

export default SNSInformation;
